import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ins1 from "../../images/instagram/1.jpg";
import ins2 from "../../images/instagram/2.jpg";
import ins3 from "../../images/instagram/3.jpg";
import ins4 from "../../images/instagram/4.jpg";
import ins5 from "../../images/instagram/5.jpg";
import ins6 from "../../images/instagram/6.jpg";
import Services from "../../api/Services";

const insData = [
  {
    id: 1,
    img: ins1,
  },
  {
    id: 2,
    img: ins2,
  },
  {
    id: 3,
    img: ins3,
  },
  {
    id: 4,
    img: ins4,
  },
  {
    id: 5,
    img: ins5,
  },
  {
    id: 6,
    img: ins6,
  },
];

const ServiceSidebar = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(Services);

  useEffect(() => {
    if (searchTerm.length > 0) {
      const searchedItems = Services.filter(
        (el) =>
          el.title
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase()) ||
          el.description
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase()) ||
          el.moreDescription
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase())
      );
      setData(searchedItems);
    } else {
      setData(Services);
    }
  }, [searchTerm]);

  return (
    <div className="service_sidebar">
      <div className="search_widget widget">
        <input
          className="fild"
          type="text"
          name="search"
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Търси специалност"
        />
      </div>
      <div className="services_widget widget">
        <h2>Специалности</h2>
        <ul>
          {data.map((serv) => (
            <li key={`${serv.slug}_slide`}>
              <Link onClick={ClickHandler} to={`/specialitiy-single/${serv.slug}`}>
                {serv.title} <span>{serv.specialists?.length}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* <div className="newsletter_widget widget">
        <h2>Newsletter</h2>
        <span>Join 20,000 Sabscribers!</span>
        <form className="emailForm" id="emailForm">
          <input
            className="fild"
            type="email"
            name="email"
            id="email2"
            placeholder="Email Address"
          />
          <button type="submit">Sign Up</button>
        </form>
        <p>By signing up you agree to our Privacy Policy</p>
      </div> */}
      <div className="instagram_widget widget">
        <h2>Instagram</h2>
        <ul>
          {insData.map((instag, iky) => (
            <li key={iky}>
              <img src={instag.img} alt="" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ServiceSidebar;
